export const blockIconsCommonactionsDateRangeNew = (
	<span className='material-symbols-outlined'>date_range</span>
);
